// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__-eczP","loader":"Loader_loader__tKAdz","spinner":"Loader_spinner__NuQNT"};